import { render, staticRenderFns } from "./PerformanceRequests.vue?vue&type=template&id=8de73b8e&scoped=true&"
import script from "./PerformanceRequests.vue?vue&type=script&lang=js&"
export * from "./PerformanceRequests.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceRequests.vue?vue&type=style&index=0&id=8de73b8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de73b8e",
  null
  
)

export default component.exports